const Calendar = require('tui-calendar');
const moment = require('moment');

(function($) {
    if  ($('#calendar').length > 0 ) {

		Calendar.setTimezoneOffsetCallback(function(timestamp) {
			return new Date(timestamp).getTimezoneOffset();
		});

        var calendar = new Calendar('#calendar', {
            defaultView: 'month',
            taskView: true,
            disableClick: false,
            usageStatistics: false,
            useCreationPopup: true,
            useDetailPopup: true,
            scheduleView: ['allday', 'time'],
            template: {
                popupIsAllDay: function() {
                    return 'Gehele dag';
                },
                popupSave: function() {
                    return 'Opslaan';
                },
                titlePlaceholder: function() {
                    return 'Naam + telefoonnummer';
                },
                popupDetailDate: function(isAllDay, start, end) {
                    var isSameDate = moment(start).isSame(end);
                    start = new Date(start);
                    end = new Date(end);
                    var endFormat = (isSameDate ? '' : 'DD-MM-YYYY ') + 'H:mm';
                    if (isAllDay) {
                        return moment(start).format('DD-MM-YYYY') + (isSameDate ? '' : ' - ' + moment(end).format('DD-MM-YYYY'));
                    }

                    return (moment(start).format('DD-MM-YYYY H:mm') + ' - ' + moment(end).format(endFormat));
                },
                // time: function(schedule) {
                //     return `<strong>${schedule.isAllDay ? `Hele dag` : moment(schedule.start.getTime()).format('HH:mm')} </strong>${schedule.title}`;
                // },
            },
            calendars: [
                {
                id: '1',
                name: 'Kleine ruimte',
                color: '#ffffff',
                bgColor: '#9e5fff',
                dragBgColor: '#9e5fff',
                borderColor: '#9e5fff'
                },
                {
                id: '2',
                name: 'Grote ruimte',
                color: '#00a9ff',
                bgColor: '#00a9ff',
                dragBgColor: '#00a9ff',
                borderColor: '#00a9ff'
                },
            ],
            month: {
                daynames: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vrij', 'Za'],
                startDayOfWeek: 1,
            }
        });

        calendar.createSchedules(
            window.schedule
        );

        calendar.on('beforeCreateSchedule', function(event) {
            var startTime = event.start;
            var endTime = event.end;
            var isAllDay = event.isAllDay;
            var guide = event.guide;
            var triggerEventName = event.triggerEventName;

            var schedule = {
                id: '1',
                category: 'time',
                dueDateClass: '',
                title: event.title,
                calendarId: event.calendarId,
                start: startTime,
                end: endTime,
                isAllDay: isAllDay
            };

            var ajaxSchedule = {
                id: '1',
                category: 'time',
                dueDateClass: '',
                title: event.title,
                calendarId: event.calendarId,
                start: startTime.toUTCString(),
                end: endTime.toUTCString(),
                isAllDay: isAllDay
            }
            $.ajax({
                url: WPURLS.ajaxurl,
                data: {
                    'action': 'add_schedule',
                    'schedule': ajaxSchedule
                },
            })
            .success(function(data) {
                location.reload();
            });

            calendar.createSchedules([schedule]);
        });

        calendar.on('beforeDeleteSchedule', function(event) {
            var schedule = event.schedule;

            $.ajax({
                url: WPURLS.ajaxurl,
                data: {
                    'action': 'delete_schedule',
                    'schedule': {
                        id: schedule.id,
                    }
                },
            })
            .success(function(data) {
                console.log(data);
            });

            calendar.deleteSchedule(
                schedule.id,
                schedule.calendarId
            );
        });

        calendar.on('beforeUpdateSchedule', function(event) {
            var schedule = event.schedule;
            var changes = event.changes;

            var ajaxSchedule = {
                id: schedule.id,
                title: changes.title ? changes.title : schedule.title,
                calendarId: changes.calendarId ? changes.calendarId : schedule.calendarId,
                start: event.start.toUTCString(),
                end: event.end.toUTCString(),
                isAllDay: changes.isAllDay ? true : false
            };

            $.ajax({
                url: WPURLS.ajaxurl,
                data: {
                    'action': 'edit_schedule',
                    'schedule': ajaxSchedule
                },
            })
            .success(function(data) {
                console.log(data);
                location.reload();
            });

            // calendar.updateSchedule(schedule.id, schedule.calendarId, changes);
        });

        calendar.on('clickSchedule', function(event) {
            // Check of de edit/delete knoppen getoond mogen worden
            $.ajax({
                url: WPURLS.ajaxurl,
                data: {
                    'action': 'show_schedule_actions',
                    'schedule': {
                        id: event.schedule.id,
                    }
                },
            })
            .success(function(data) {
                if(data.success) {
                    $('.tui-full-calendar-popup-detail .tui-full-calendar-section-button').show();
                } else {
                    $('.tui-full-calendar-popup-detail .tui-full-calendar-section-button').hide();
                }
            });
        });

        $('[data-action="move-today"]').on('click', function(){
            calendar.today();
            setDate();
        });
        $('[data-action="move-prev"]').on('click', function(){
            calendar.prev();
            setDate();
        });
        $('[data-action="move-next"]').on('click', function(){
            calendar.next();
            setDate();
        });

        function setDate() {
            var month = [
                "Januari",
                "Februari",
                "Maart",
                "April",
                "Mei",
                "Juni",
                "Juli",
                "Augustus",
                "September",
                "Oktober",
                "November",
                "December",
            ];

            let CalendarMonth = calendar.getDate().getMonth();
            let CalendarYear = calendar.getDate().getFullYear();
            $('#renderRange').text(month[CalendarMonth]+ ' '+CalendarYear);
        }
    }

})(jQuery);
